import { useABVersionsStore, QuarterlySubscriptionVersion, OrderRecipeABVersion } from "@/stores/abVersions";

// ----- Quarterly Subscription AB Version -----
export const initializeQuarterlySubscriptionABTest = (to: any) => {
  const quarterlySubscriptionABVersionQuery = to.query.quarterly_subscription_version || "";
  if (to.query.contactId && to.query.quarterly_subscription_version) return true; // * This are Abandoned Recipe Links and Formula version will be initialized from version saved on HS on Contact level

  if (
    quarterlySubscriptionABVersionQuery &&
    Object.values(QuarterlySubscriptionVersion).includes(quarterlySubscriptionABVersionQuery)
  ) {
    setQuarterlySubscriptionABVersion(quarterlySubscriptionABVersionQuery);
  } else {
    window.addEventListener("payment_type", setQuarterlySubscriptionABVersionListener);
  }
};

export const setQuarterlySubscriptionABVersionListener = (event: CustomEvent<QuarterlySubscriptionVersion>) => {
  setQuarterlySubscriptionABVersion(event.detail);
};

export const setQuarterlySubscriptionABVersion = (version: QuarterlySubscriptionVersion) => {
  const abVersionsStore = useABVersionsStore();
  abVersionsStore.setQuarterlySubscriptionABVersion(version);
  return true;
};
// ----- Quarterly Subscription AB Version -----

// ----- Order Recipe AB Version -----
export const initializeOrderRecipeABTest = (to: any) => {
  const orderRecipeABVersionQuery = to.query.order_recipe_version || "";
  if (to.query.contactId && to.query.order_recipe_version) return true; // * This are Abandoned Recipe Links and Formula version will be initialized from version saved on HS on Contact level

  if (orderRecipeABVersionQuery && Object.values(OrderRecipeABVersion).includes(orderRecipeABVersionQuery)) {
    setOrderRecipeABVersion(orderRecipeABVersionQuery);
  } else {
    window.addEventListener("order_recipe_ab_version", setOrderRecipeABVersionListener);
  }
};

export const setOrderRecipeABVersionListener = (event: CustomEvent<OrderRecipeABVersion>) => {
  setOrderRecipeABVersion(event.detail);
};

export const setOrderRecipeABVersion = (version: OrderRecipeABVersion) => {
  const abVersionsStore = useABVersionsStore();
  abVersionsStore.setOrderRecipeABVersion(version);
  return true;
};
// -----  Order Recipe AB Version -----
